import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import _ from 'lodash';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';
import { IAccountStatusDto, IAccountStatusDtoStatusEnum } from '@/types';

import { EnrollmentAccountHistoryPayload } from '../EnrollmentsAccountHistory.types';

export const QUERY_KEY = 'GET_ENROLLMENT_ACCOUNT_HISTORY';

interface Response {
  account_statuses: IAccountStatusDto[];
}
interface Params {
  accountId?: string;
}

const ALLOWED_STATUSES = [
  IAccountStatusDtoStatusEnum.OPEN,
  IAccountStatusDtoStatusEnum.CLOSED,
  IAccountStatusDtoStatusEnum.PENDING,
];
const useGetEnrollmentAccountHistoryQuery = ({ accountId }: Params) => {
  const { isLoading, data } = useQuery(
    [QUERY_KEY, accountId],
    // TODO: review the type, they don't match
    () => api.get<Response>(API_URL.ACCOUNTS_BY_ID(accountId || '')),
    {
      enabled: !!accountId,
    }
  );

  const formattedData = useMemo(() => {
    const list = data?.data?.account_statuses || [];

    const ordered = _.orderBy(list, (item) => (item.valid_from ? dayjs(new Date(item.valid_from)) : false), [
      'desc',
    ]);

    const filtered = ordered.filter((item) => item.status && ALLOWED_STATUSES.includes(item.status));
    const result = filtered.map((item) => {
      const newItem: EnrollmentAccountHistoryPayload = {
        id: `${item.id}`,
        status: item.status || IAccountStatusDtoStatusEnum.CLOSED,
        from: item.valid_from ? dayjs(item.valid_from).format(DEFAULT_DATE_FORMAT) : '',
        to: item.valid_to ? dayjs(item.valid_to).format(DEFAULT_DATE_FORMAT) : '',
      };
      return newItem;
    });
    return result;
  }, [data?.data]);

  return {
    data: formattedData,
    isLoading,
  };
};
export default useGetEnrollmentAccountHistoryQuery;
